import { render } from "./Scadenzari.vue?vue&type=template&id=5ae30b22"
import script from "./Scadenzari.vue?vue&type=script&lang=js"
export * from "./Scadenzari.vue?vue&type=script&lang=js"

import "./Scadenzari.vue?vue&type=style&index=0&id=5ae30b22&lang=css"

import exportComponent from "C:\\Users\\germa\\dev\\dcpower.client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__